export default "__VITE_ASSET__BdBTjX41__"